import React, { FC } from 'react';
import { Box } from '~Styles';
import PulsatingCircle, { Circle } from '~ComponentsImproved/PulsatingCircle';
import Countdown from './Countdown';
import { useI18n } from '~Hooks';

interface Props {
  compStatus: {
    isUpcoming: boolean;
    isOngoing: boolean;
    isCompleted: boolean;
  };
  endDate: string;
}

const TimeLeftIndicator: FC<Props> = ({ compStatus, endDate }) => {
  const { i18n } = useI18n();
  return (
    <Box display="flex" alignItems="center" gap="xs">
      {compStatus.isOngoing ? <PulsatingCircle /> : <Circle color="var(--colorBlueGray200)" />}
      <Countdown
        compStatus={compStatus}
        preText={
          compStatus.isOngoing
            ? `${i18n('Competitions.Status.Live')} ${i18n('Competitions.Countdown.With')}`
            : compStatus.isCompleted
            ? i18n('Competitions.Countdown.HasEnded')
            : i18n('Competitions.Status.NotStarted')
        }
        endDate={endDate}
      />
    </Box>
  );
};

export default TimeLeftIndicator;
